module.exports = __webpack_public_path__ + "static/img/ikea_icon.2a09c64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ikea_icon.png
// module id = SKXd
// module chunks = 8